import { useState, useCallback } from 'react';

/**
 * Hook für Object Snap (OSnap) Einstellungen.
 * Verwaltet welche Snap-Typen aktiv sind.
 */
export function useOsnapSettings(initialOsnap = null) {
  const defaultOsnap = {
    enabled: true,
    end: true,      // Endpunkte
    mid: true,      // Mittelpunkte
    int: true,      // Schnittpunkte
    near: false,    // Nächster Punkt auf Linie
    perp: false,    // Senkrecht
  };

  const [osnap, setOsnap] = useState(initialOsnap || defaultOsnap);

  // Toggle einzelner Snap-Typ oder gesamtes OSnap
  const toggleOsnap = useCallback((snapType) => {
    if (snapType) {
      setOsnap(prev => ({ ...prev, [snapType]: !prev[snapType] }));
    } else {
      setOsnap(prev => ({ ...prev, enabled: !prev.enabled }));
    }
  }, []);

  // Alle Snaps ein/aus
  const enableAllSnaps = useCallback(() => {
    setOsnap(prev => ({
      ...prev,
      enabled: true,
      end: true,
      mid: true,
      int: true,
      near: true,
      perp: true,
    }));
  }, []);

  const disableAllSnaps = useCallback(() => {
    setOsnap(prev => ({
      ...prev,
      enabled: false,
    }));
  }, []);

  // Einzelnen Snap setzen
  const setSnapType = useCallback((snapType, value) => {
    setOsnap(prev => ({ ...prev, [snapType]: value }));
  }, []);

  return {
    osnap,
    setOsnap,
    toggleOsnap,
    enableAllSnaps,
    disableAllSnaps,
    setSnapType,
  };
}

export default useOsnapSettings;
